import React from 'react';
import CenteredSkeleton from './common/CenteredSkeleton.jsx';
import ButtonSkeleton from './common/ButtonSkeleton.jsx';
import SkeletonComponent from './common/SkeletonComponent.jsx';
import "react-loading-skeleton/dist/skeleton.css";

const MonitoringReportProjectReportsSkeleton = () => {
  return (
    <>
      <div className='row mb-1'>
        <div className="col-xs-7 ">
          <h1 style={{marginBottom: 5}}>{' '}
            <SkeletonComponent variant='text' />
          </h1>
        </div>
        <div className='col-xs-5'>
          <div className='mt-2 pull-right'>
            <ButtonSkeleton buttonContent={`${I18n.t("send_project_report_request")}`}/>
          </div>
        </div>
      </div>
      <div className='row mb-1' style={{height: 30}}>
        <div className='col-xs-10  d-flex align-items-center' style={{height: '100%'}}>
          <CenteredSkeleton variant='rounded' width='100%' />
        </div>
        <div className="col-xs-2  search-container pull-right" style={{height: '100%'}}>
          <SkeletonComponent variant='rounded' width='100%' height='100%' />          
        </div>
      </div>
      <div className='row' style={{height: 1128, paddingTop: 10}}>
        <CenteredSkeleton />
      </div>
    </>
  )
}

export default MonitoringReportProjectReportsSkeleton